import React from 'react';
import { Box, List, ListItem } from '@mui/joy';
import { useTranslation } from 'react-i18next';

const CellCommaSeparatedList = ({ type, value, field, splitcharacter }) => {
    const { t } = useTranslation();

    let limit = 0;
    if (typeof value === 'string' && splitcharacter) {
        value = value.split(splitcharacter ?? ',');
        limit = value.length;
    }

    return (
        <Box className={"list-element-cell cell-generics cell-generics-"+type}>
            {limit > 0 && (
                <List className="cell-generics-list">
                    {value.map((item, k) => {
                        if (k >= limit || item == null) return;
                        return (
                            <ListItem key={k} className={'cell-generics-list-item cell-generics-list-item-action '+item}>
                                <span className="name" title={t(item)}>{t(item)}</span>
                            </ListItem>
                        );
                    })}
                </List>
            )}
        </Box>
    )
    
}

export default CellCommaSeparatedList;